import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames';
import { trans, getResourcePath } from '@spotahome/soyuz/client';

import TextBlock from '@components/TextBlock';

import FaceBubble from '@components/FaceBubble';

import './TenantsBubbleSection.scss';

const tenantList = [
  {
    name: 'Amélie',
    infoKey: 'landlord.landing.tenant-bubble.amelie.info',
    imageSource: '/images/landlord/tenant-headshot-1.jpg',
    size: 'big',
    sizeMobile: 'big',
    showOnMobile: true,
    showOnTablet: true
  },
  {
    name: 'Iván',
    infoKey: 'landlord.landing.tenant-bubble.ivan.info',
    imageSource: '/images/landlord/tenant-headshot-2.jpg',
    size: 'small',
    sizeMobile: 'small',
    showOnMobile: true,
    showOnTablet: true
  },
  {
    name: 'Malika',
    infoKey: 'landlord.landing.tenant-bubble.malika.info',
    imageSource: '/images/landlord/tenant-headshot-3.jpg',
    size: 'big',
    sizeMobile: 'small',
    showOnMobile: true,
    showOnTablet: true
  },
  {
    name: 'Antonio',
    infoKey: 'landlord.landing.tenant-bubble.antonio.info',
    imageSource: '/images/landlord/tenant-headshot-4.jpg',
    size: 'small',
    sizeMobile: 'small',
    showOnMobile: true,
    showOnTablet: true
  },
  {
    name: 'Isabela',
    infoKey: 'landlord.landing.tenant-bubble.isabela.info',
    imageSource: '/images/landlord/tenant-headshot-5.jpg',
    size: 'big',
    showOnTablet: true
  },
  {
    name: 'Aravinth',
    infoKey: 'landlord.landing.tenant-bubble.aravinth.info',
    imageSource: '/images/landlord/tenant-headshot-6.jpg',
    size: 'small'
  },
  {
    name: 'Zachary',
    infoKey: 'landlord.landing.tenant-bubble.zachary.info',
    imageSource: '/images/landlord/tenant-headshot-7.jpg',
    size: 'big'
  }
];

const MQ_SHOW_ON_MOBILE = 767;
const MQ_SHOW_ON_TABLET = 1000;

const TenantsBubbleSection = ({ className }) => {
  const showOnMobile = useMediaQuery({
    maxWidth: MQ_SHOW_ON_MOBILE
  });

  const showOnTablet = useMediaQuery({
    maxWidth: MQ_SHOW_ON_TABLET,
    minWidth: MQ_SHOW_ON_MOBILE + 1
  });

  const sectionClass = classNames('tenant-bubble-section', className);
  const bubblesContainerClass = classNames(
    'tenant-bubble-section__bubbles-container',
    {
      'tenant-bubble-section__bubbles-container--mobile': showOnMobile,
      'tenant-bubble-section__bubbles-container--tablet': showOnTablet
    }
  );
  return (
    <section className={sectionClass}>
      <div className="tenant-bubble-section__text-container">
        <TextBlock
          title={trans('landlord.landing.standard.tenants.title')}
          content={trans('landlord.landing.standard.tenants.subtitle')}
          alignTo="center"
          titleTag="h2"
          titleSize="big"
          contentSize="medium"
        />
      </div>
      <div className={bubblesContainerClass}>
        {tenantList.map(
          tenantItem =>
            ((!showOnMobile && !showOnTablet) ||
              (showOnMobile && tenantItem.showOnMobile) ||
              (showOnTablet && tenantItem.showOnTablet)) && (
              <div
                key={tenantItem.name}
                className={classNames(
                  'tenant-bubble-section__bubble',
                  `tenant-bubble-section__bubble--${tenantItem.size}`
                )}
              >
                <FaceBubble
                  size={showOnMobile ? tenantItem.sizeMobile : tenantItem.size}
                  imageSource={getResourcePath(tenantItem.imageSource)}
                  faceName={tenantItem.name}
                  faceJobTitle={trans(tenantItem.infoKey)}
                />
              </div>
            )
        )}
      </div>
    </section>
  );
};

TenantsBubbleSection.propTypes = {
  className: PropTypes.string
};

TenantsBubbleSection.defaultProps = {
  className: ''
};

export default TenantsBubbleSection;
